import React from 'react';
import PropTypes from 'prop-types';

import { MUIModal, Flex } from 'Components/Base';

import ReplayButton from './Button/ReplayButton';
import NextSubsectionButton from './Button/NextSubsectionButton';
import InformationContent from './Content/InformationContent';
import FeedbackContent from './Content/FeedbackContent';

const VideoEndingOverlay = ({
  onCloseOverlay,
  onReplayClick,
  countdown,
  enabledCountdown,
  onAutoPlay,
  isLastSubsectionInCourse,
  onClickVideoEndingOverlayContent,
  onOpenOnlineSolution,
  providerName,
  shouldShowOverlay,
}) => {
  return (
    <MUIModal
      modalStyle={{ borderRadius: 3, width: '100%', maxWidth: '440px' }}
      open={shouldShowOverlay}
      onCloseModal={onCloseOverlay}
      closeIcon={false}
    >
      <Flex flexDirection={'column'}>
        <Flex justifyContent={'center'} mb={6}>
          <ReplayButton
            onClick={(event) => {
              // The button fires a click for mouse, touch, and keyboard (Enter) activation.
              // pointerType marks the pointer device ('touch' for a tap); a keyboard-driven
              // click reports detail === 0. Everything else is a real mouse click.
              const native = event?.nativeEvent;
              let interactionMethod = 'mouse';
              if (native?.pointerType === 'touch') {
                interactionMethod = 'touch_gesture';
              } else if (native?.detail === 0) {
                interactionMethod = 'keyboard';
              }
              onReplayClick?.(interactionMethod);
            }}
          />
          <NextSubsectionButton
            countdown={countdown}
            enabledCountdown={enabledCountdown}
            onAutoPlay={onAutoPlay}
            isLastSubsectionInCourse={isLastSubsectionInCourse}
          />
        </Flex>
        <InformationContent
          onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent}
          onOpenOnlineSolution={onOpenOnlineSolution}
          providerName={providerName}
        />
        <FeedbackContent onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent} />
      </Flex>
    </MUIModal>
  );
};

VideoEndingOverlay.propTypes = {
  onCloseOverlay: PropTypes.func,
  onReplayClick: PropTypes.func,
  countdown: PropTypes.number,
  enabledCountdown: PropTypes.bool,
  onAutoPlay: PropTypes.func,
  isLastSubsectionInCourse: PropTypes.bool,
  onClickVideoEndingOverlayContent: PropTypes.func,
  providerName: PropTypes.string,
  onOpenOnlineSolution: PropTypes.func,
  shouldShowOverlay: PropTypes.bool,
};

export default VideoEndingOverlay;
